import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const useOutsideClick = (ref, handleClose, updaters) => {
  useEffect(() => {
    const handleClick = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        handleClose(e);
      }
    };

    const handleKeyDown = e => {
      if (e.target.tagName !== 'BODY' && !ref.current.contains(e.target)) {
        handleClose(e);
      }

      if (e.key === 'Escape') {
        handleClose(e);
      }
    };

    document.addEventListener('click', handleClick, true);
    document.addEventListener('touchstart', handleClick, true);
    document.addEventListener('keydown', handleKeyDown, true);

    return () => {
      document.removeEventListener('click', handleClick, true);
      document.removeEventListener('touchstart', handleClick, true);
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [handleClose, ref, updaters]);
};

const withExternalClick = WrappedComponent => {
  const ResultComponent = props => {
    const ref = useRef(null);

    useOutsideClick(ref, props.handleClose, [props.isOpen]);

    return <WrappedComponent {...props} ref={ref} />;
  };

  ResultComponent.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
  };

  return ResultComponent;
};

export default withExternalClick;
